import React from 'react'
import { Box, Button, Link, Typography } from "@mui/material";
import { Menu as LangMenu, MenuItem as LangMenuItem } from "@mui/material";
import { LIGHTCOLORS } from "../../Utils/constants.js";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import nafLogo from '../../assets/logo.svg';
import { DropDownIcon } from "../../Components/Layouts/CustomIcons";

const languages = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'ch', label: 'Chinese' },
];

const Terms = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [langAnchorEl, setLangAnchorEl] = React.useState(null);
  const openLangMenu = Boolean(langAnchorEl);

  const handleLangMenuOpen = (event) => setLangAnchorEl(event.currentTarget);
  const handleLangMenuClose = () => setLangAnchorEl(null);
  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    handleLangMenuClose();
  };

  // Use only light theme colors
  const containerBG = LIGHTCOLORS.BackgroundMenu;
  const spancolor = LIGHTCOLORS.BodyLightBackground;
  const headingcolor2 = LIGHTCOLORS.BodyLightBackground;
  const subtitletext = LIGHTCOLORS.GreyScale60;
  const linkcolor = LIGHTCOLORS.Primary500;
  const dropCircle = LIGHTCOLORS.GreyScale50;
  const dropIcon = LIGHTCOLORS.GreyScale80;
  const headingcolor = LIGHTCOLORS.HeadingLightBackground;
  const containerBackground = LIGHTCOLORS.BackgroundCard;
  const primaryColor = LIGHTCOLORS.Primary100;
  const btnBG = LIGHTCOLORS.GreyScale20;

  return (
    <Box sx={{ backgroundColor: containerBG, p: { xs: 1, sm: 3, md: 5 } }}>
      <div>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <img className='naf-term-logo-img' style={{
            width: '70px',
            height: '70px',
            borderRadius: '10px',
            marginBottom: "10px"
          }} src={nafLogo} alt="naf-term-logo" />



          {/* translations dropdown */}
          <Box
            onClick={handleLangMenuOpen}
            sx={{
              background: containerBackground,
              display: 'flex',
              alignItems: 'center',
              borderRadius: '24px',
              padding: '10px 12px',
              cursor: 'pointer',
              border: `1px solid ${LIGHTCOLORS.GreyScale30}`,
              '&:hover': {
                backgroundColor: containerBackground
              }
            }}
          >
            <Typography sx={{ color: headingcolor, fontWeight: 500, fontSize: '0.9rem', marginRight: '4px' }}>
              {languages.find(lang => lang.code === i18n.language)?.label || 'Language'}
            </Typography>
            <DropDownIcon
              color1={dropCircle}
              color2={dropIcon}
              style={{
                marginLeft: '4px',
                transform: openLangMenu ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease',
              }}
            />
          </Box>

          <LangMenu
            anchorEl={langAnchorEl}
            open={openLangMenu}
            onClose={handleLangMenuClose}
            MenuListProps={{ 'aria-labelledby': 'language-button' }}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '12px',
                minWidth: 100,
                padding: '4px 0',
                backgroundColor: containerBackground,
                color: headingcolor,
              }
            }}
          >
            {languages.map(({ code, label }) => (
              <LangMenuItem
                key={code}
                selected={i18n.language === code}
                onClick={() => handleLanguageChange(code)}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: primaryColor,
                  },
                  '&:hover': {
                    backgroundColor: btnBG,
                  },
                }}
              >
                {label}
              </LangMenuItem>
            ))}
          </LangMenu>



        </Box>

        <Box sx={{ textAlign: 'center', marginTop: { xs: 4, sm: 3, md: 2 } }}>
          {/* <Box className="back-btn-sec" xs={{ display: 'flex', alignItems: 'center' }}>
            <Button className="back-btn"
              onClick={() => navigate("/term")}
              sx={{
                width: "30px",
                height: "30px",
                padding: 0,
                borderRadius: "50%",
                bgcolor: btnBG,
                minWidth: "unset",
                p: 3
              }}
            >
              <KeyboardBackspaceIcon sx={{ color: linkcolor }} />
            </Button>
            <Typography className="back-btn-text" sx={{ fontSize: "25px", pl: 2, color: '#000', fontWeight: '500' }}>
              {t('term.back')}
            </Typography>
          </Box> */}

          <Typography sx={{
            fontSize: 'calc(1rem + 1vw)',
            color: headingcolor,
            fontWeight: 600,
            letterSpacing: "0.62px",
            textAlign: 'center',
            mb: 6
          }}>
            {t('term.TermsConditions')}
          </Typography>
          <Box></Box>
        </Box>

        <Box className='faq-sec' >
          <Box alignItems="center" sx={{ marginBottom: '40px' }} className="trust-company-logo">
            <Typography className="trust-title" style={{ color: headingcolor }}>
              {t('term.PrivacyPolicy')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              {t('term.Controller')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              {t('term.Company')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              {t('term.Address')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              {t('term.PostalCode')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              <span className='terms-span ' >{t('term.Phone')} </span> {t('term.PhoneNumber')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              <span className='terms-span ' >{t('term.Email')} </span> {t('term.EmailAddress')}
            </Typography>
            <Typography style={{ color: subtitletext }} className="terms-li">
              <span className='terms-span ' >{t('term.Web')} </span>
              <Link sx={{ color: linkcolor, listStyle: 'none', textDecoration: 'none' }} href="https://www.vendinaf.com" target="_blank" >
                {t('term.WebAddress')}
              </Link>
            </Typography>
            <Typography>

            </Typography>

          </Box>

          <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.TrustandSafetySubtitle')}</p>
          <Box className="terms-sec">
            <ol className="terms-ol login-term">

              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: spancolor }}>
                  {t('term.PurposeLegal')}
                </span>
                {t('term.PurposeLegalText')}
              </li>

              <Typography className='terms-span sublist' style={{ color: headingcolor2 }}>
                {t('term.LegalBases')}

              </Typography>

              <ul id="ul-li-1" className="terms-subol">


                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>   </span>
                  {t('term.LegalBases1')}
                </li>
                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>   </span>
                  {t('term.LegalBases2')}
                </li>
              </ul>


              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: spancolor }}>{t('term.GeneralInformation')}</span>
                {t('term.GeneralInformationtext')}
              </li>
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.DataControllerandContact')}</span>
                {t('term.DataControllerandContactText')}
              </li>
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: spancolor }}> {t('term.YourRights')} </span> {t('term.YourRightsText')}
              </li>
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.DataRecipients')} </span>
                {t('term.DataRecipientsText')}
              </li>

              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.DataRetentionandDeletion')} </span>
                {t('term.DataRetentionandDeletionText')}
              </li>


              <ul id="ul-li" className="terms-subol" style={{ marginBottom: '10px', paddingLeft: "20px" }}>

                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.ContractData')} </span>
                  {t('term.ContractDataText')}
                </li>
                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.LogData')} </span>
                  {t('term.LogDataText')}
                </li>
                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.LocationTransactionData')} </span>
                  {t('term.LocationTransactionDataText')}
                </li>

              </ul>


              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.TypesOfDataProcessed')} </span>
                {t('term.TypesOfDataProcessedText')}
              </li>
            </ol>

            <ul className="terms-subol" style={{ marginTop: '10px' }}>
              <li className="terms-subli disc" style={{ color: subtitletext }}>
                <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.DataProcessed')}</span>
                {t('term.DataProcessedText')}
              </li>
              <li className="terms-subli disc" style={{ color: subtitletext }}>
                <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.ProcessingPurposes')}</span>
                {t('term.ProcessingPurposesText')}
              </li>
              <li className="terms-subli disc" style={{ color: subtitletext }}>
                <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.LegalBasisforProcessing')}</span>
                {t('term.LegalBasisforProcessingText')}
              </li>
            </ul>


            <ol className="terms-ol login-term" start={8}>
              {[
                ['AIPoweredFeaturesandMachineLearning', 'AIPoweredFeaturesandMachineLearningText'],
                ['DataSharing', 'DataSharingText'],
                ['Hosting', 'HostingText'],
                ['DataSecurity', 'DataSecurityText'],
                ['InternationalDataTransfers', 'InternationalDataTransfersText'],
                ['UserRights', 'UserRightsText'],
                ['TerminationandAccount', 'TerminationandAccountText'],
                ['LawandJurisdiction', 'LawandJurisdictionText'],
              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>

          </Box>
          {/* terms of use */}
          <Box className="security-sec" sx={{ margin: '100px 0px' }}>
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.TermsofUse')}</h1>


            <ol className="terms-ol login-term">
              {[
                ['Scope', 'ScopeText'],
                ['SubjectContract', 'SubjectContractText'],
                ['Registration_Access', 'Registration_AccessText'],
                ['CustomerObligations', 'CustomerObligationsText'],
                ['Availability', 'AvailabilityText'],
                ['Liability', 'LiabilityText'],
                ['ContractDurationTermination', 'ContractDurationTerminationText'],
                ['DataProtection', 'DataProtectionText']

              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>
          </Box>
          {/* security */}
          <Box className="security-sec" sx={{ margin: '100px 0px' }}>
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.Security')}</h1>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.SecurityText')}</p>

            <ol className="terms-ol login-term">
              {[
                ['DataEncryption', 'DataEncryptionText'],
                ['AccessControl', 'AccessControlText'],
                ['RegularSecurityAudits', 'RegularSecurityAuditsText'],
                ['Compliance', 'ComplianceText']
              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>
          </Box>
          {/* changes */}
          <Box className="security-sec" sx={{ margin: '100px 0px' }}>
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.LoginNotice')}</h1>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.LoginNoticeText')}</p>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.LoginNoticeMandatory')}</p>


          </Box>

          <Box className="attr-sec">
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.Attribution')}</h1>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.AttributionText')}</p>

            <ol className="terms-ol login-term">
              {[
                ['Magnific', 'MagnificText'],
                ['FigmaCommunity', 'FigmaCommunityText'],
                ['NounProject', 'NounProjectText']
              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>
          </Box>
        </Box>
      </div>
    </Box>
  )
}

export default Terms;
